export const SUPPORTED_LANGUAGES = {
  EN: 'en',
  ES: 'es'
} as const
export const LANGUAGE_KEY = 'language'
export const LANGUAGE_OVERRIDE_KEY = 'isLanguageOverride'
